import React from 'react';
import { observer } from 'mobx-react';
import MobilePacketDataLimits from './MobilePacketDataLimits';
import PacketGiftTooltip from './PacketGiftTooltip';
import SwitchPacketLink from './SwitchPacketLink';
import { Item } from './types';

interface MobilePacketProps {
  dataField: string;
  item: Item;
  selected: boolean;
}

const MobilePacket: React.FC<MobilePacketProps> = (props) => {
  const { item } = props;

  return (
    <React.Fragment>
      <div className="text">
        <MobilePacketDataLimits item={item} />
      </div>
      <div className="text">
        {item.giftTooltip && <PacketGiftTooltip item={item} />}
        <SwitchPacketLink switchLink={item.switchLink} />
      </div>
    </React.Fragment>
  );
};

export default observer(MobilePacket);
